export const MasterDepositFormValidations = {
  file: [{ type: 'fileRequired', message: 'A file must be selected' }],
  amount: [
    { type: 'required', message: 'Amount is required' },
    { type: 'min', value: 0, message: 'Amount must be zero or more' },
  ],
  status: [{ type: 'required', message: 'Status is required' }],

  // Optional fields like updated_by, va_no, va_bank_code, bank_ref_id, is_settlement can be added if needed
};
